export default "__VITE_ASSET__Cm$jIp7U__"